// extracted by mini-css-extract-plugin
export var showcaseContainer = "HomeProjectShowcase-module--showcaseContainer--354Xf";
export var row = "HomeProjectShowcase-module--row--2MUTO";
export var linksContainer = "HomeProjectShowcase-module--linksContainer--3pRfR";
export var link = "HomeProjectShowcase-module--link--1S00_";
export var linkIcon = "HomeProjectShowcase-module--linkIcon--2AVKm";
export var showcaseImageContainer = "HomeProjectShowcase-module--showcaseImageContainer--QNNgj";
export var showcaseGatsbyImageContainer = "HomeProjectShowcase-module--showcaseGatsbyImageContainer--2WIMV";
export var showcaseImage = "HomeProjectShowcase-module--showcaseImage--3pm0o";
export var labelsContainer = "HomeProjectShowcase-module--labelsContainer--1TZnW";
export var label = "HomeProjectShowcase-module--label--3E3j3";